"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InlineResponse20022ToJSON = exports.InlineResponse20022FromJSONTyped = exports.InlineResponse20022FromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function InlineResponse20022FromJSON(json) {
    return InlineResponse20022FromJSONTyped(json, false);
}
exports.InlineResponse20022FromJSON = InlineResponse20022FromJSON;
function InlineResponse20022FromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'data': !(0, runtime_1.exists)(json, 'data') ? undefined : (json['data'].map(_1.OWGameResponseFromJSON)),
        'paginationInfo': !(0, runtime_1.exists)(json, 'paginationInfo') ? undefined : (0, _1.PaginationInfoFromJSON)(json['paginationInfo']),
    };
}
exports.InlineResponse20022FromJSONTyped = InlineResponse20022FromJSONTyped;
function InlineResponse20022ToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'data': value.data === undefined ? undefined : (value.data.map(_1.OWGameResponseToJSON)),
        'paginationInfo': (0, _1.PaginationInfoToJSON)(value.paginationInfo),
    };
}
exports.InlineResponse20022ToJSON = InlineResponse20022ToJSON;
